import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import TableCell from '@mui/material/TableCell';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { textSelectionNone } from 'shared/design-system/base/TrueImpactText';

interface TableCellDeleteProps {
  text: string | number;
  onClick: () => unknown;
}

const StyledTableCell = styled(TableCell)<{ showIcon: boolean }>`
  cursor: pointer;
  position: relative;
  ${textSelectionNone}
  .icon-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: ${COLORS.whiteBase};
  }
`;

const TableCellDelete: React.FC<TableCellDeleteProps> = ({ text, onClick }) => {
  const [showDeleteIcon, setShowDeleteIcon] = useState<boolean>(false);

  const handleShow = useCallback(() => {
    setShowDeleteIcon(true);
  }, [setShowDeleteIcon]);
  const handleHide = useCallback(() => {
    setShowDeleteIcon(false);
  }, [setShowDeleteIcon]);

  return (
    <StyledTableCell
      showIcon={showDeleteIcon}
      onMouseOver={handleShow}
      onMouseLeave={handleHide}
      onClick={onClick}
    >
      {text}
      {showDeleteIcon && (
        <div className="icon-wrapper">
          <FontAwesomeIcon color={COLORS.critical} icon={faTrash} />
        </div>
      )}
    </StyledTableCell>
  );
};

export default TableCellDelete;
